/**
 * Categoria: Controle de Presença (Operação)
 * Fluxo de chamada diária: matrícula em turma, registro de presença e justificativas.
 */
export const CONTROLE_PRESENCA = {
    id: "controle_presenca",
    title: "Controle de Presença (Operação)",
    icon: "ph-light ph-calendar-check",
    description: "Como matricular alunos em turmas, registrar presença/ausência e justificar faltas na rotina diária.",
    steps: [
        {
            id: "presenca_fase1",
            title: "Fase 1 — Matrícula do Aluno na Turma",
            description: "O aluno precisa estar vinculado a uma turma antes de aparecer na chamada:",
            subItems: [
                {
                    id: "presenca_matricula",
                    icon: "ph-light ph-user-circle-plus",
                    title: "Vincular Aluno à Turma",
                    content: `<p class="mb-2"><strong>Pré-requisito:</strong> O aluno deve possuir um <strong>Plano Ativo</strong> (status "Ativo"). Leads só podem ser agendados via Aula Experimental.</p>
                              <p class="mb-2"><strong>Como realizar:</strong> Acesse o <em>Perfil do Aluno</em>, vá até a aba <strong>"Matrículas"</strong> e clique em <strong>"Nova Matrícula"</strong>. Selecione a turma desejada (dia/horário) compatível com o plano do aluno.</p>
                              <p class="mb-0"><strong>O que acontece:</strong> O sistema insere automaticamente o aluno em todas as sessões futuras daquela turma, dentro do período de validade do plano. Ele passará a constar na lista de chamada a partir da próxima sessão.</p>`
                }
            ]
        },
        {
            id: "presenca_fase2",
            title: "Fase 2 — Registro de Presença na Grade",
            description: "A rotina diária do professor ou recepcionista para controlar a frequência:",
            subItems: [
                {
                    id: "presenca_acessar_grade",
                    icon: "ph-light ph-squares-four",
                    title: "Acessar a Grade de Aulas",
                    content: `<p class="mb-0"><strong>Como acessar:</strong> No menu lateral, vá em <strong>Técnico > Grade</strong>. A grade exibirá todas as turmas do dia organizadas por horário e área. Clique na turma desejada para abrir a lista de chamada da sessão.</p>`
                },
                {
                    id: "presenca_marcar",
                    icon: "ph-light ph-check-square",
                    title: "Marcar Presença ou Ausência",
                    content: `<p class="mb-2"><strong>Como realizar:</strong> Dentro da sessão da turma, a lista de alunos matriculados será exibida. Para cada aluno, marque o status:</p>
                              <ul class="mb-0">
                                  <li class="mb-1"><span class="badge bg-success">Presente</span>: O aluno compareceu à aula.</li>
                                  <li><span class="badge bg-danger">Ausente</span>: O aluno faltou à aula.</li>
                              </ul>`
                },
                {
                    id: "presenca_justificativa",
                    icon: "ph-light ph-note-pencil",
                    title: "Justificar Ausência",
                    content: `<p class="mb-2"><strong>Quando usar:</strong> Sempre que o aluno faltar e houver um motivo registrado (atestado médico, viagem, etc.).</p>
                              <p class="mb-0"><strong>Como realizar:</strong> Ao marcar o aluno como <strong>Ausente</strong>, um campo de justificativa será habilitado. Informe o motivo da falta para manter o histórico completo e facilitar a gestão de reposições ou análise de frequência.</p>`
                }
            ]
        }
    ]
};
